module.exports = __webpack_public_path__ + "img/savanah_content_img_02.7295afb6.jpg";